import React, { useState, useEffect } from "react";
import {
  Layout,
  Menu,
  Button,
  Drawer,
  Dropdown,
  Divider,
  Col,
  Row,
  Spin,
} from "antd";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import PageRoutes from "../../utils/routes";
import {
  MenuOutlined,
  DownOutlined,
  UserOutlined,
  TeamOutlined,
  HomeOutlined,
} from "@ant-design/icons";
import useAuth from "../../hooks/useAuth";
import useAuthService from "../../services/useAuthService";

const { Header, Sider, Content } = Layout;

export default function HomeLayout() {
  const [isMobile, setIsMobile] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const { firmLogout } = useAuthService();
  const { firmAuth } = useAuth();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleDrawer = () => {
    setDrawerVisible(!drawerVisible);
  };

  const handleMenuClick = () => {
    if (isMobile) {
      setDrawerVisible(false); // Close drawer after navigation in mobile view
    }
  };

  const menuItems = [
    {
      key: PageRoutes.firmHome,
      icon: <UserOutlined />,
      label: (
        <NavLink to={PageRoutes.firmHome} onClick={handleMenuClick}>
          Ana Sayfa
        </NavLink>
      ),
    },
    {
      key: "jobManagement",
      icon: <TeamOutlined />,
      label: "İlan Yönetimi",
      children: [
        {
          key: PageRoutes.createAdvert,
          icon: <HomeOutlined />,
          label: (
            <NavLink to={PageRoutes.createAdvert} onClick={handleMenuClick}>
              İlan Aç
            </NavLink>
          ),
        },
        {
          key: PageRoutes.adverts,
          icon: <TeamOutlined />,
          label: (
            <NavLink to={PageRoutes.adverts} onClick={handleMenuClick}>
              İlanlar
            </NavLink>
          ),
        },
      ],
    },
    {
      key: "companyManagement",
      icon: <TeamOutlined />,
      label: "Firma Yönetimi",
      children: [
        {
          key: PageRoutes.firmInfo,
          icon: <UserOutlined />,
          label: (
            <NavLink to={PageRoutes.firmInfo} onClick={handleMenuClick}>
              Şirket Bilgilerim
            </NavLink>
          ),
        },
        {
          key: PageRoutes.firmDocuments,
          icon: <UserOutlined />,
          label: (
            <NavLink to={PageRoutes.firmDocuments} onClick={handleMenuClick}>
              Şirket Belgelerim
            </NavLink>
          ),
        },
        {
          key: PageRoutes.firmUsers,
          icon: <UserOutlined />,
          label: (
            <NavLink to={PageRoutes.firmUsers} onClick={handleMenuClick}>
              Şirket Kullanıcıları
            </NavLink>
          ),
        },
        {
          key: PageRoutes.addFirmUser,
          icon: <UserOutlined />,
          label: (
            <NavLink to={PageRoutes.addFirmUser} onClick={handleMenuClick}>
              Kullanıcı Ekle
            </NavLink>
          ),
        },
      ],
    },
  ];

  return (
    <Spin spinning={firmLogout.isPending}>
      <Layout style={{ minHeight: "100vh" }}>
        {/* Sidebar for larger screens */}
        {!isMobile && (
          <Sider
            theme="light"
            collapsible
            collapsed={collapsed}
            onCollapse={setCollapsed}>
            <div
              className="logo"
              style={{ color: "black", fontSize: "20px", padding: "16px" }}>
              <Col
                style={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  maxWidth: "100%",
                }}>
                {firmAuth.user.firm.companyName}
              </Col>
            </div>

            <Menu theme="light" mode="inline" items={menuItems} />
          </Sider>
        )}
        <Drawer
          title="Menu"
          placement="left"
          onClose={() => setDrawerVisible(false)}
          open={drawerVisible}>
          <Menu theme="light" mode="inline" items={menuItems} />
        </Drawer>

        <Layout>
          <Header
            style={{
              background: "#fafafa",
              padding: "0 16px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
            }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                maxWidth: "1600px",
                margin: "0 ",
              }}>
              {isMobile && (
                <Button
                  icon={<MenuOutlined />}
                  onClick={toggleDrawer}
                  style={{ border: "none", marginRight: "16px" }}
                />
              )}

              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <Dropdown
                  menu={{
                    items: [
                      {
                        key: "settings",
                        label: (
                          <NavLink to={PageRoutes.personnelHome}>
                            Ayarlar
                          </NavLink>
                        ),
                      },
                      {
                        key: "help",
                        label: <NavLink to={PageRoutes.home}>Yardım</NavLink>,
                      },
                      {
                        key: "logout",
                        label: (
                          <NavLink
                            to={PageRoutes.home}
                            onClick={() => {
                              firmLogout.mutate();
                            }}
                            style={{
                              textDecoration: "none",
                              color: "inherit",
                              display: "block",
                              padding: "12px 16px",
                            }}>
                            Çıkış Yap
                          </NavLink>
                        ),
                      },
                    ],
                  }}
                  trigger={["click"]}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                      gap: "8px",
                    }}>
                    <div
                      style={{
                        width: "32px",
                        height: "32px",
                        borderRadius: "50%",
                        backgroundColor: "#6f42c1",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}>
                      <span style={{ fontSize: "16px", color: "white" }}>
                        {firmAuth.user.name.charAt(0)}
                      </span>
                    </div>
                    <span style={{ fontSize: "16px" }}>
                      {firmAuth.user.name}
                    </span>
                    <DownOutlined style={{ fontSize: "12px" }} />
                  </div>
                </Dropdown>
              </div>
            </div>
          </Header>

          {/* Content */}
          <Content
            style={{
              backgroundColor: "white",
              minHeight: "calc(100vh - 64px)",
              padding: "24px",
              paddingTop: 10,
            }}>
            <Outlet />
          </Content>
        </Layout>
      </Layout>
    </Spin>
  );
}
